import enterpriseClient, { getAuthHeader } from "./enterpriseClient";

/**
 * Fetch user type details from the enterprise service.
 *
 * New Endpoint:
 * GET /api/neoin/usertype
 * Headers: Authorization: Bearer <token>
 *
 * @param {string} [customToken] - Optional explicit auth token override
 * @returns {Promise<any>} User type data response from server
 */
export const getUserTypeAPI = async (customToken) => {
  const authHeader = customToken
    ? (customToken.startsWith("Bearer ") ? customToken : `Bearer ${customToken}`)
    : getAuthHeader();

  if (!authHeader) {
    throw new Error("Authentication token is missing");
  }

  try {
    const response = await enterpriseClient.get("/api/neoin/usertype", {
      headers: {
        Authorization: authHeader,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching user type:", error);
    return Promise.reject(error?.response?.data || error);
  }
};

/**
 * Alias for backward compatibility with existing code calling getUserIdDetailsHelperAPI
 * Accepts optional userId parameter but uses the new /api/neoin/usertype endpoint.
 */
export const getUserIdDetailsHelperAPI = async (_userId, customToken) => {
  return getUserTypeAPI(customToken);
};

export default getUserTypeAPI;
